// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"98bd8814","52":"607ffcea","125":"4813aac2","198":"e8824e08","498":"8bef3ec0","703":"dd222d96","787":"9e9f4ffd","802":"9ee3af87","830":"311c3a41"}[chunkId] + ".chunk.js";
};